module.exports = __webpack_public_path__ + "assets/img/plugIn.f3b87924.png";